/* eslint-disable import/prefer-default-export */
/* eslint-disable func-names */
/* HELPER FUNCTIONS */
export const throttle = (func, limit) => {
  let inThrottle = false
  return function(...args) {
    const context = this
    if (!inThrottle) {
      func.apply(context, args)
      inThrottle = true
      setTimeout(() => (inThrottle = false), limit)
    }
  }
}

/**
 * Takes a moment date as input and return the year and week
 * in following format YYYY-ww or YYYY-WW
 *
 * e.g. 2020-50
 * @param {moment} date
 */
export const formatYearAndWeek = date => {
  if (date) {
    // if first weeek of the next year falls in the last week of current year
    const week =
      date.month() === 0 && date.isoWeek() >= 52
        ? date.format('YYYY-ww') // then consider 'week' i.e. 2021-01
        : date.format('YYYY-WW') // otherwise consider 'iso week' i.e. 2020-53

    return week
  }
  return null
}
